import { useData } from '@/components';
import { useIsMobile } from '@/hooks';

const BREAKPOINT = 1024;

const useActiveHeaderSlice = () => {
  const { header } = useData();
  const { isMobile } = useIsMobile(BREAKPOINT);

  return isMobile ? header.data.activeMobile : header.data.activeDesktop;
};

export { useActiveHeaderSlice };
